import './css/app.scss';

import './ts/slider';

import './ts/neto.js';
import loadSprite from './ts/loadSprite';
import dropdown from './ts/dropdowns';
import mobMenu from './ts/mobMenu';
import popups from './ts/popups';
import lazyLoad from './ts/lazyLoad';
import tabs from './ts/tabs';
import accordian from './ts/accordian';
import readMore from './ts/readmore';
import copySubAdv from './ts/copySubAdv';
import textChange from './ts/textChange';
import stickyHeader from './ts/stickyHeader';

loadSprite.init();
dropdown.init();
mobMenu.init();
popups.init();
lazyLoad.init();
tabs.init();
accordian.init();
readMore.init();
copySubAdv.init();
textChange.init();
stickyHeader.init();




 








